export const en = {

    upload_max_file : 'You can upload a maximum of 3 files.',
    upload_message : 'Drag the file here or <em>click to upload.</em>',
    upload_tip_1 : 'You can only upload files in doc, docx, and pdf formats.',


    notification_warning_title: 'Attention!',
    notification_destroy: 'The data you have selected will be permanently deleted. Do you confirm?',
    notification_destroy_cancel: 'Deletion process cancelled.',
    notification_sending_cancel: 'Sending process cancelled.',
    notification_reCaptchaTitle: 'I am not a Robot',

    dialog_file_upload_title: 'Upload File',
    dialog_file_upload_description: 'Hassle-free Printing and High Craftsmanship Quality',
    dialog_offer_title: 'Request a Quote',
    dialog_offer_description: 'Hassle-free Printing and High Craftsmanship Quality',

    misc_or: 'Or',
    misc_yes: 'Yes',
    misc_no: 'No',
    misc_search_not_found: 'Sorry, no results were found matching your search.',

    inputs_choice: 'Your Choice',
    inputs_your_message: 'Your Message...',
    inputs_your_email: 'Your Email Address',
    inputs_email: 'Email',
    inputs_first_name: 'First Name',
    inputs_last_name: 'Last Name',
    inputs_your_phone: 'Your Phone Number',
    inputs_phone: 'Phone',
    inputs_country: 'Country',
    inputs_city: 'City',
    inputs_town: 'Town/District',
    inputs_subject: 'Subject',
    inputs_message: 'Message',
    inputs_your_full_name: 'Your Full Name',
    inputs_full_name: 'Full Name',
    inputs_has_access_web_site: 'I consent to publishing on the website.',

    button_send: 'Send',
    button_save: 'Save',
}
